import { CONFIG } from '@/configs';
import { OrganizationMember } from '@/types/types.user';

interface CredentialAuth {
  authId: string;
  projectId: string;
  token: string;
}

const buildHeaders = (auth: CredentialAuth) => ({
  authorization: auth.token,
  'x-auth-id': `${auth.authId}`,
  'x-project-id': `${auth.projectId}`,
});

interface ListOrganizationMembersResponse {
  data: OrganizationMember[];
  pagination: { page: number; page_size: number; total_item: number };
}

export const listOrganizationMembers = async (
  page: number,
  pageSize: number,
  auth: CredentialAuth,
): Promise<{ members: OrganizationMember[]; totalItem: number }> => {
  const res = await fetch(
    `${CONFIG.connection.web}/v1/organizations/members?page=${page}&pageSize=${pageSize}`,
    { method: 'GET', headers: buildHeaders(auth) },
  );
  if (!res.ok) {
    throw new Error(
      'Unable to get all the users for your organization, please try again in sometime.',
    );
  }
  const body = (await res.json()) as ListOrganizationMembersResponse;
  return { members: body.data, totalItem: body.pagination.total_item };
};
